import { Pet } from "@main/pets/models/Pet";

export class Customer {
    public id: number;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;
    public name: string;
    public surnames: string;
    public phone: string;
    public mobile: string;
    public email: string;
    public nif: string;
    public address: string;
    public city: string;
    public state: string;
    public postal_code: string;
    public observations: string;
    public pets: Pet[];

    constructor() {
        this.id = 0;
        this.name = '';
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        this.surnames = '';
        this.phone = '';
        this.mobile = '';
        this.email = '';    
        this.nif = '';
        this.address = '';
        this.city = '';
        this.state = '';
        this.postal_code = '';
        this.observations = '';
        this.pets = [];
    }
}